import { createGlobalState } from '@/utilities/createGlobalState'
import { type ApiStatus } from './useApi'

export const useApiStatus = createGlobalState<ApiStatus>('apiStatus', ({
  initialized: false,
  needsRefresh: false,
  session: undefined,
}))
